const getOrdersModuleAssetUrl = () => {
	return new Worker(new URL("../../workers/myOrdersPDFWorker.worker.tsx", import.meta.url), { type: "module" });
};

export default getOrdersModuleAssetUrl;
